export default "__VITE_ASSET__q9NHjtvo__"